export default __webpack_public_path__ + "static/blobedFeature3-c2ca28271c890c15e0b6b28f23312bb5.png";